import { AccessTime, CalendarToday } from "@mui/icons-material";
import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDrawerFooter from "../../../../components/CustomDrawar/customDrawarFooter";
import CustomDrawerHeader from "../../../../components/CustomDrawar/customDrawarHeader";
import { setTabActive } from "../../../../lib/slices/tabActiveSlice";
import { getBranchDetails } from "../../../../services/Branches";
import {
  calculateEndTime,
  checkAndReturnArray,
  formatDuration,
} from "../../../../utils";
const CheckoutStep = ({
  selectedTeam,
  selectedTime,
  selectedDate,
  selectedServices,
  handleCreateAppointment,
  setIsLoading,
}) => {
  console.log(selectedDate, "selectedDateselectedDateselectedDate");

  const tabActive = useSelector((state) => state.tabActive.tabs);
  const { user } = useSelector((state) => state.user);
  const [totalDuration, setTotalDuration] = useState(0);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [totalPrice, setTotalPrice] = useState(0);
  const [teamMember, setTeamMember] = useState([]);
  const [branchDetails, setBranchDetails] = useState(null);

  console.log(branchDetails, "branchDetailsbranchDetailsbranchDetails");

  const dispatch = useDispatch();

  useEffect(() => {
    getBranchDataDetials();
  }, []);

  useEffect(() => {
    handleCheckTeamMember();

    setTotalDuration(
      selectedServices.reduce((acc, item) => acc + item.duration, 0)
    );
    setTotalPrice(selectedServices.reduce((acc, item) => acc + item.price, 0));
  }, [selectedServices]);

  const handleCheckTeamMember = async () => {
    try {
      const result = checkAndReturnArray(selectedTeam);
      setTeamMember(result);
    } catch (error) {
      console.log("🚀 ~ handleCheckTeamMember ~ error:", error);
    }
  };

  const getBranchDataDetials = async () => {
    try {
      setIsLoading(true);
      const response = await getBranchDetails(selectedBranch[0]);
      setIsLoading(false);
      let data = response?.data?.data;
      if (response?.status == 200 || response?.status == 201) {
        setBranchDetails(data);
      } else {
        setBranchDetails(null);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerrorerrorgetBranchDataDetials");
    }
  };

  return (
    <>
      <CustomDrawerHeader
        title={"Confirm Appointment"}
        onBack={() => dispatch(setTabActive(3))}
      />
      <Box sx={{ p: 2, pb: 10 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Box
              bgcolor="divider"
              alignItems="center"
              justifyContent="center"
              width="84px"
              height="84px"
              borderRadius="10px"
              overflow={"hidden"}
            >
              <img
                alt="Glow And Salon"
                src={branchDetails?.coverImage}
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
          </Grid>
          <Grid item xs textAlign="top">
            <Typography fontSize={14} fontWeight={600}>
              {branchDetails?.displayName}
            </Typography>
            <Typography fontSize={12} color="text.secondary">
              {branchDetails?.about}
              <br />
              {branchDetails?.location?.address}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Date and Time */}
        <Grid
          container
          spacing={1}
          gap="10px"
          padding="0 10px"
          alignItems="center"
        >
          <CalendarToday fontSize="small" />
          <Typography fontSize={12}>
            {moment(selectedDate).format("ddd, DD MMM YYYY")}
          </Typography>
        </Grid>

        <Grid
          container
          spacing={1}
          gap="10px"
          padding="0 10px"
          alignItems="center"
          mt="8px"
        >
          <AccessTime fontSize="small" />
          <Typography fontSize={12}>
            {calculateEndTime(selectedTime, totalDuration)}
          </Typography>
        </Grid>

        <Box my="10px">
          <Typography variant="subtitle1" fontWeight={500} sx={{ mb: 1 }}>
            Your Selected Services
          </Typography>
          {selectedServices?.map((service, index) => (
            <Box key={index} mb={2}>
              <Typography
                fontSize={15}
                fontWeight={500}
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "gray",
                }}
              >
                {service.serviceName}
              </Typography>
              <Typography
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "gray",
                }}
                fontSize={12}
              >
                {service.serviceDescription}
              </Typography>
              <Typography
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "gray",
                }}
                fontSize={12}
              >
                {service.duration} min
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Total Price */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Typography variant="subtitle1">Total Price</Typography>
          <Typography variant="subtitle1" color="primary">
            {totalPrice} SAR
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Typography variant="subtitle1">Total Duration</Typography>
          <Typography variant="subtitle1" color="primary">
            {formatDuration(totalDuration)}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Worker Info */}
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Workers
        </Typography>
        <Box
          sx={{
            overflow: "auto",
            "&::-webkit-scrollbar": {
              // width: "2px",
              height: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#d4d2d2",
              borderRadius: "4px",
              "&:hover": {
                background: "#c2c0c0",
              },
            },
          }}
        >
          <Grid container spacing={2} sx={{ mb: 1, flexWrap: "nowrap" }}>
            {teamMember?.map((team, index) => (
              <Grid item key={index}>
                <Box
                  sx={{
                    justifyContent: "start",
                    width: 120,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    margin: "5px",
                    gap: "10px",
                    width: "210px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                    padding: "5px",
                  }}
                >
                  <Avatar
                    alt={team.teamMemberName}
                    src={team?.teamMemberPro}
                    sx={{ width: 48, height: 48 }}
                  />
                  <Box
                    flexDirection="column"
                    padding={0}
                    margin={0}
                    textAlign="start"
                    alignItems="start"
                  >
                    <Typography fontSize={12} lineHeight={1}>
                      {team.teamMemberName}
                    </Typography>
                    <Typography
                      variant="caption"
                      lineHeight={0}
                      color="text.secondary"
                      fontSize={10}
                      noWrap
                    >
                      {team.teamMemberJobTitle}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          maxWidth: "450px",
          width: "450px",
          backgroundColor: "white",
          zIndex: 1000,
        }}
      >
        <CustomDrawerFooter
          activeStep={tabActive}
          btnTitle={"Book Now"}
          onNext={handleCreateAppointment}
        />
      </Box>
    </>
  );
};

export default CheckoutStep;
